import { Currency } from "@/models/Currency";
import {State} from "@/store/room/state";

const mutations = {
  SET_TABLE_DATA: (state, data: Currency[]) => {
    state.tableData = data;
  },
  SET_CURRENCY_DETAILS: (state, details: Currency) => {
    state.details = details;
  },
  SET_LOADING_STATE: (state, val: boolean): void => {
    state.isLoading = val;
  },
  SET_SNACKBAR_VISIBILITY: (state: State, val: boolean) => {
    state.isSnackBarVisible = val;
  },
  SET_SNACKBAR_MESSAGE: (state: State, message: string) => {
    state.snackbarMsg = message;
  },
  SET_SNACKBAR_STATUS: (state: State, status: string) => {
    state.snackbarStatus = status;
  },
  CLEAR_SNACKBAR: (state): void => {
    state.isSnackBarVisible = false;
  },
  CLEAR_CURRENCY_DETAILS: (state): void => {
    state.details = new Currency();
  },
  SET_DIALOG_VISIBLE: (state, val: boolean) => {
    state.dialogVisible = val;
  },
};

export default mutations;
